/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-underscore-dangle */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-nested-ternary */
import { TableContainer, Pagination, FormSelect } from '@patchworkhealth/web-components'
import moment from 'moment'
import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { formatTimeInTZ } from '../../Helpers/momentHelpers'
import { AuthHeaderSearch } from '../AuthHeader/AuthHeader'
import { TableHeaderContainer } from '../Tables/TableElements'
import { checkStatus, paginationOptions, checkProposals, LeaveStatus } from './helpers/BlockBookingsHelpers'
import { CheckboxSVG, CheckboxWrap, HiddenCheckbox, StyledCheckbox } from './helpers/BlockComponents'
import { CreateBlockIcon, FilterIcon, HideTimesheet, ShowTimesheet } from './helpers/BlockIcons'

const parseBlockIdFromUrl = (url) => {
  const searchParams = new URLSearchParams(url)
  return searchParams.get('id')
}

function BlockList({
  blockData,
  error,
  inputs,
  loading,
  pageInfo,
  pagination,
  resetFilters,
  selectBlockHandler,
  setFiltersOpen,
  setPagination,
  setRowsSearched,
  showBlockModal,
  showCreateModal,
  handleChange,
  value,
  handleCompletedBlocks,
  showCompletedBlocks,
  toggleTimesheet,
  toggleAmendedTimesheet,
  timesheets,
}) {
  const { showFilters, rowsSearched, selectedBlock, showClearFilters, activeTimesheet, amendedTimesheet } = inputs
  const prePopulatedBlockId = parseBlockIdFromUrl(window.location.search)

  const [local, setLocal] = useState(prePopulatedBlockId || '')

  useEffect(() => {
    if (value === null) {
      return
    }

    setLocal(value.join())
  }, [value])

  useEffect(() => {
    if (prePopulatedBlockId) {
      handleChange(prePopulatedBlockId)
    }
  }, [prePopulatedBlockId])

  const submitHandler = (e) => {
    e.preventDefault()

    if (local[0].toUpperCase() === 'B') {
      handleChange(local.slice(1))
      return
    }
    handleChange(local)
  }

  const changeHandler = (event) => {
    const { value: val } = event.target

    if (val === '') {
      setLocal('')
      handleChange('')
      return
    }

    setLocal(val)
  }

  const checkDepartments = (row) => {
    const ans = row.departments.map((b) => b.name).filter((v, i, a) => a.indexOf(v) === i)

    if (ans.length > 1) {
      return 'Multiple Departments'
    }

    return ans[0]
  }

  const checkBlockStatus = (row, result) => {
    if (row.provisionallyBooked) {
      return <LeaveStatus status="PROVISIONAL">Provisional</LeaveStatus>
    }

    if (row.status === 'BOOKED') {
      return <LeaveStatus status="BOOKED">Booked</LeaveStatus>
    }

    if (row.status === 'DELETED') {
      return <LeaveStatus status="DELETED">Deleted</LeaveStatus>
    }

    if (row.status === 'DRAFT') {
      return <LeaveStatus status="DRAFT">Draft</LeaveStatus>
    }

    if (Number.isInteger(result)) {
      return (
        <LeaveStatus onClick={() => showBlockModal(row)} status="APPLICATIONS">
          <span>{result}</span>
          {`${result === 1 ? 'APPLICATION' : result > 1 ? 'APPLICATIONS' : result}`}
        </LeaveStatus>
      )
    }

    const proposals = checkProposals(row)

    if (proposals > 0) {
      return (
        <LeaveStatus onClick={() => showBlockModal(row)} status="APPLICATIONS">
          <span>{proposals}</span>
          {`${proposals === 1 ? 'PROPOSAL' : 'PROPOSALS'}`}
        </LeaveStatus>
      )
    }

    return (
      <LeaveStatus onClick={() => null} status={result}>
        {result}
      </LeaveStatus>
    )
  }

  const workerDetails = (row) => {
    const firstName = row.bookedBy.user !== undefined ? row.bookedBy.user?.firstName : row.bookedBy?.firstName
    const lastName = row.bookedBy.user !== undefined ? row.bookedBy.user?.lastName : row.bookedBy?.lastName

    const isAgencyBooking = row?.bookedBy?.__typename === 'AgencyRegistration'

    const clickWorker = () => {
      if (isAgencyBooking) {
        showBlockModal(row)
        return
      }
      window.open(`/workers?worker_id=${row.bookedBy.user.id}`, '_blank').focus()
    }

    return (
      <td onClick={clickWorker}>
        <strong style={{ textDecoration: 'underline', cursor: 'pointer' }}>
          {firstName} {lastName}
        </strong>
      </td>
    )
  }

  const component = (
    <TableContainer error={error} loading={loading || !blockData} style={{ minWidth: 1100 }}>
      <TableHead data-cy="shift-table-header">
        <tr>
          <th />
          <th>Block Name</th>

          <th>Block Date</th>
          <th>Created At</th>
          <th>Shifts</th>
          {activeTimesheet && <th>Active Timesheets</th>}
          {amendedTimesheet && <th>Amended Timesheets</th>}
          <th>Location</th>
          <th>staff Group</th>
          {!activeTimesheet && <th>Grade</th>}
          <th>Type</th>
          <th>Requested By</th>
          <th>Status</th>
          <th>Worker</th>
        </tr>
      </TableHead>
      <tbody data-testid="shifts">
        {blockData?.shiftBlocks &&
          blockData?.shiftBlocks?.nodes?.map((row) => {
            const result = checkStatus(row)

            const doesContractExist = row.deContractVersionAssignment !== null

            return (
              <TableRow key={row.id}>
                <td>
                  <CheckboxWrap checked style={{ marginTop: 14 }}>
                    <HiddenCheckbox
                      isChecked={selectedBlock.id === row.id}
                      onChange={() => {
                        if (Number(selectedBlock.id) === Number(row.id)) {
                          selectBlockHandler(false)
                          return
                        }
                        selectBlockHandler(row)
                      }}
                    />
                    <StyledCheckbox isChecked={selectedBlock.id === row.id} name="greg">
                      <CheckboxSVG />
                    </StyledCheckbox>
                  </CheckboxWrap>
                </td>
                <td style={{ width: 160, display: 'flex', paddingTop: doesContractExist ? 22 : 32 }}>
                  <div
                    onClick={() => showBlockModal(row)}
                    style={{
                      cursor: 'pointer',
                      marginLeft: 14,
                    }}
                  >
                    <span style={{ display: 'block', textDecoration: 'underline' }}>
                      <strong>{row?.uid} </strong>
                    </span>
                    <span> {row?.name}</span>
                  </div>
                  {doesContractExist && (
                    <div
                      style={{
                        marginLeft: 12,
                        marginTop: 4,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <svg
                        fill="none"
                        height="15"
                        style={{ marginBottom: 2 }}
                        viewBox="0 0 15 9"
                        width="22"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.58178 8.16552C3.56172 8.16552 2.69688 7.81071 1.98727 7.1011C1.27766 6.39149 0.922852 5.52665 0.922852 4.50659C0.922852 3.48652 1.27766 2.62168 1.98727 1.91207C2.69688 1.20246 3.56172 0.847656 4.58178 0.847656H11.567C12.2988 0.847656 12.9253 1.10822 13.4464 1.62934C13.9675 2.15046 14.2281 2.77691 14.2281 3.5087C14.2281 4.24048 13.9675 4.86694 13.4464 5.38806C12.9253 5.90918 12.2988 6.16974 11.567 6.16974H5.24704C4.78136 6.16974 4.38775 6.00897 4.06621 5.68742C3.74466 5.36588 3.58389 4.97227 3.58389 4.50659C3.58389 4.04091 3.74466 3.64729 4.06621 3.32575C4.38775 3.00421 4.78136 2.84344 5.24704 2.84344H11.567V3.84133H5.24704C5.05855 3.84133 4.90044 3.90519 4.77271 4.03292C4.64498 4.16065 4.58134 4.31854 4.58178 4.50659C4.58178 4.69508 4.64565 4.85319 4.77338 4.98092C4.90111 5.10865 5.059 5.17229 5.24704 5.17185H11.567C12.0327 5.17185 12.4263 5.01108 12.7479 4.68953C13.0694 4.36799 13.2302 3.97438 13.2302 3.5087C13.2302 3.04302 13.0694 2.6494 12.7479 2.32786C12.4263 2.00632 12.0327 1.84555 11.567 1.84555H4.58178C3.85 1.84555 3.22354 2.10611 2.70242 2.62723C2.1813 3.14835 1.92074 3.7748 1.92074 4.50659C1.92074 5.23837 2.1813 5.86483 2.70242 6.38595C3.22354 6.90707 3.85 7.16763 4.58178 7.16763H11.567V8.16552H4.58178Z"
                          fill="#545454"
                        />
                      </svg>

                      {row.deContractVersionAssignment.signedAt ? (
                        <svg fill="none" height="5" viewBox="0 0 5 5" width="5" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="2.5" cy="2.5" fill="#AEDDAE" r="2.5" />
                        </svg>
                      ) : (
                        <svg fill="none" height="5" viewBox="0 0 5 5" width="5" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="2.5" cy="2.5" fill="#E6515D" r="2.5" />
                        </svg>
                      )}
                    </div>
                  )}
                </td>

                <td style={{ minWidth: 100 }}>
                  <span style={{ display: 'block' }}> {formatTimeInTZ(row?.startDate, 'Do MMM YY')} - </span>
                  <span> {formatTimeInTZ(row?.endDate, 'Do MMM YY')}</span>
                </td>
                <td style={{ minWidth: 100 }}> {formatTimeInTZ(row?.createdAt, 'Do MMM YY')}</td>
                <td>{row.shiftCount}</td>
                {activeTimesheet && (
                  <td style={{ color: 'red', fontWeight: 'bold', fontSize: '15 !important' }}>
                    {row.status === 'BOOKED' ? row.activeTimesheets : ' - '}
                  </td>
                )}
                {amendedTimesheet && (
                  <td style={{ color: 'blue', fontWeight: 'bold', fontSize: '15 !important' }}>
                    {row.status === 'BOOKED' ? row.amendedTimesheets : ' - '}
                  </td>
                )}

                <td>{checkDepartments(row)}</td>
                <td>{row?.staffGroup?.label}</td>
                <td style={{ color: row.grade.colour, fontWeight: 'bold' }}>{row?.grade?.label.slice(0, 50)}</td>
                <TableIconRow>
                  {row?.sentToAgency && row.autoCascadeTriggers.length === 0 && (
                    <AgencyShiftIcon tier={row?.agencyTier} />
                  )}

                  {row.autoCascadeTriggers.length > 0 &&
                    row.autoCascadeTriggers[0].triggerType === 'auto_send_to_agency' && (
                      <AgencyAwaitingCascadeIcon text={row?.autoCascadeTriggers[0]?.triggeredAt} />
                    )}

                  {row.autoCascadeTriggers.length > 0 && row.autoCascadeTriggers[0].triggerType === 'update_tier' && (
                    <AgencyUpdateCascadeIcon tier={row?.agencyTier} />
                  )}

                  {!row?.sentToAgency && row.autoCascadeTriggers.length === 0 && <BankShiftIcon />}
                </TableIconRow>
                <td>{row?.hubUser?.fullName}</td>
                <td>{checkBlockStatus(row, result)}</td>
                {row.bookedBy ? workerDetails(row) : <td />}
              </TableRow>
            )
          })}
      </tbody>
    </TableContainer>
  )

  return (
    <BlockWrapper>
      <TableHeaderContainer>
        <div style={{ display: 'flex' }}>
          <form onSubmit={submitHandler}>
            <AuthHeaderSearch onChange={changeHandler} placeholder="Search Block IDs" value={local} />
          </form>

          <button className="btn btn-white" onClick={() => setFiltersOpen()} style={{ marginRight: 20 }} type="button">
            <FilterIcon />
            {showFilters ? 'Close' : 'Add'} Filters
          </button>

          {showClearFilters && (
            <button className="btn btn-white" onClick={() => resetFilters()} type="button">
              Clear Filters
            </button>
          )}
        </div>

        <div style={{ paddingRight: '10px' }}>
          {timesheets.timesheet && activeTimesheet && (
            <button className="btn btn-white" onClick={() => toggleAmendedTimesheet(!amendedTimesheet)} type="button">
              {amendedTimesheet ? 'Hide' : 'Show'} Amended Timesheets
              {!amendedTimesheet && <ShowTimesheet />}
              {amendedTimesheet && <HideTimesheet />}
            </button>
          )}

          {timesheets.timesheet && (
            <button
              className="btn btn-white"
              onClick={() => toggleTimesheet(!activeTimesheet)}
              style={{ marginLeft: '10px' }}
              type="button"
            >
              {activeTimesheet ? 'Hide' : 'Show'} Timesheets
              {!activeTimesheet && <ShowTimesheet />}
              {activeTimesheet && <HideTimesheet />}
            </button>
          )}

          <button
            className="btn btn-white"
            onClick={() => handleCompletedBlocks()}
            style={{ marginLeft: '10px' }}
            type="button"
          >
            Show {showCompletedBlocks ? 'All' : ' In-Progress'} Blocks
          </button>

          <button
            className="btn btn-cyan"
            onClick={() => showCreateModal(true)}
            style={{ marginLeft: '10px' }}
            type="button"
          >
            <CreateBlockIcon />
            Create Block
          </button>
        </div>
      </TableHeaderContainer>
      {component}

      <div style={{ position: 'relative', width: '100%', margin: '10px 0px 160px 0px' }}>
        <Pagination pageInfo={pageInfo} pagination={pagination} setPagination={setPagination} />
        <PaginationWrapper>
          <span style={{ width: 250 }}>Blocks per page:</span>
          <FormSelect
            onChange={(e) => setRowsSearched(e.value)}
            options={paginationOptions}
            style={{ width: 50 }}
            value={paginationOptions.filter((val) => val.value === rowsSearched)}
          />
        </PaginationWrapper>
      </div>
    </BlockWrapper>
  )
}

export default BlockList

const PaginationWrapper = styled.div`
  position: absolute;
  top: 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  right: 0px;
  width: 250px;
`

const BlockWrapper = styled.div`
  margin-top: -130px;
  margin-bottom: 40px;
  padding: 20px;
`

const TableRow = styled.tr`
  * {
    font-size: 12px !important;
  }

  &:nth-child(even) {
    background-color: #f9fbfd;
  }

  th {
    padding: 8px;
  }

  td {
    padding: 14px 10px;
  }
`

export const TableIconRow = styled.td`
  min-width: 150px;
  position: relative;
  overflow: visible !important;
  svg:hover + div {
    opacity: 1 !important;
  }
`

const TableHead = styled.thead`
  th {
    padding: 9px;
  }
`

// Shift Type Icon -----
export function AgencyShiftIcon({ tier }) {
  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        fontSize: '10px',
        flexDirection: 'column',
        lineHeight: '10px',
      }}
    >
      <svg fill="none" height="19" viewBox="0 0 18 19" width="18" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.4702 6.38093H11.2054C11.4003 6.38093 11.5873 6.30348 11.7252 6.16562C11.863 6.02776 11.9405 5.84078 11.9405 5.64581C11.9405 5.45084 11.863 5.26386 11.7252 5.126C11.5873 4.98814 11.4003 4.91069 11.2054 4.91069H10.4702C10.2753 4.91069 10.0883 4.98814 9.95042 5.126C9.81256 5.26386 9.73511 5.45084 9.73511 5.64581C9.73511 5.84078 9.81256 6.02776 9.95042 6.16562C10.0883 6.30348 10.2753 6.38093 10.4702 6.38093V6.38093ZM10.4702 9.32141H11.2054C11.4003 9.32141 11.5873 9.24396 11.7252 9.10609C11.863 8.96823 11.9405 8.78125 11.9405 8.58629C11.9405 8.39132 11.863 8.20434 11.7252 8.06648C11.5873 7.92862 11.4003 7.85117 11.2054 7.85117H10.4702C10.2753 7.85117 10.0883 7.92862 9.95042 8.06648C9.81256 8.20434 9.73511 8.39132 9.73511 8.58629C9.73511 8.78125 9.81256 8.96823 9.95042 9.10609C10.0883 9.24396 10.2753 9.32141 10.4702 9.32141V9.32141ZM6.79464 6.38093H7.52976C7.72472 6.38093 7.9117 6.30348 8.04956 6.16562C8.18743 6.02776 8.26488 5.84078 8.26488 5.64581C8.26488 5.45084 8.18743 5.26386 8.04956 5.126C7.9117 4.98814 7.72472 4.91069 7.52976 4.91069H6.79464C6.59967 4.91069 6.41269 4.98814 6.27483 5.126C6.13697 5.26386 6.05952 5.45084 6.05952 5.64581C6.05952 5.84078 6.13697 6.02776 6.27483 6.16562C6.41269 6.30348 6.59967 6.38093 6.79464 6.38093V6.38093ZM6.79464 9.32141H7.52976C7.72472 9.32141 7.9117 9.24396 8.04956 9.10609C8.18743 8.96823 8.26488 8.78125 8.26488 8.58629C8.26488 8.39132 8.18743 8.20434 8.04956 8.06648C7.9117 7.92862 7.72472 7.85117 7.52976 7.85117H6.79464C6.59967 7.85117 6.41269 7.92862 6.27483 8.06648C6.13697 8.20434 6.05952 8.39132 6.05952 8.58629C6.05952 8.78125 6.13697 8.96823 6.27483 9.10609C6.41269 9.24396 6.59967 9.32141 6.79464 9.32141V9.32141ZM15.6161 15.2024H14.8809V2.70533C14.8809 2.51037 14.8035 2.32339 14.6656 2.18553C14.5278 2.04766 14.3408 1.97021 14.1458 1.97021H3.85416C3.6592 1.97021 3.47221 2.04766 3.33435 2.18553C3.19649 2.32339 3.11904 2.51037 3.11904 2.70533V15.2024H2.38392C2.18896 15.2024 2.00198 15.2798 1.86412 15.4177C1.72625 15.5555 1.6488 15.7425 1.6488 15.9375C1.6488 16.1324 1.72625 16.3194 1.86412 16.4573C2.00198 16.5951 2.18896 16.6726 2.38392 16.6726H15.6161C15.811 16.6726 15.998 16.5951 16.1359 16.4573C16.2737 16.3194 16.3512 16.1324 16.3512 15.9375C16.3512 15.7425 16.2737 15.5555 16.1359 15.4177C15.998 15.2798 15.811 15.2024 15.6161 15.2024ZM9.73511 15.2024H8.26488V12.2619H9.73511V15.2024ZM13.4107 15.2024H11.2054V11.5268C11.2054 11.3318 11.1279 11.1448 10.99 11.007C10.8522 10.8691 10.6652 10.7916 10.4702 10.7916H7.52976C7.33479 10.7916 7.14781 10.8691 7.00995 11.007C6.87209 11.1448 6.79464 11.3318 6.79464 11.5268V15.2024H4.58928V3.44045H13.4107V15.2024Z"
          fill="#0000009c"
        />
      </svg>
      <p style={{ margin: '2px 0px', fontSize: '11px !important', fontWeight: 500 }}>AGENCY</p>
      <p style={{ margin: 0 }}>Tier {tier?.rank ?? 0}</p>
    </div>
  )
}

// Shift Type Icon -----
export function AgencyUpdateCascadeIcon({ tier }) {
  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        fontSize: '10px',
        flexDirection: 'column',
        lineHeight: '10px',
      }}
    >
      <svg fill="none" height="19" viewBox="0 0 18 19" width="18" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.4702 6.38093H11.2054C11.4003 6.38093 11.5873 6.30348 11.7252 6.16562C11.863 6.02776 11.9405 5.84078 11.9405 5.64581C11.9405 5.45084 11.863 5.26386 11.7252 5.126C11.5873 4.98814 11.4003 4.91069 11.2054 4.91069H10.4702C10.2753 4.91069 10.0883 4.98814 9.95042 5.126C9.81256 5.26386 9.73511 5.45084 9.73511 5.64581C9.73511 5.84078 9.81256 6.02776 9.95042 6.16562C10.0883 6.30348 10.2753 6.38093 10.4702 6.38093V6.38093ZM10.4702 9.32141H11.2054C11.4003 9.32141 11.5873 9.24396 11.7252 9.10609C11.863 8.96823 11.9405 8.78125 11.9405 8.58629C11.9405 8.39132 11.863 8.20434 11.7252 8.06648C11.5873 7.92862 11.4003 7.85117 11.2054 7.85117H10.4702C10.2753 7.85117 10.0883 7.92862 9.95042 8.06648C9.81256 8.20434 9.73511 8.39132 9.73511 8.58629C9.73511 8.78125 9.81256 8.96823 9.95042 9.10609C10.0883 9.24396 10.2753 9.32141 10.4702 9.32141V9.32141ZM6.79464 6.38093H7.52976C7.72472 6.38093 7.9117 6.30348 8.04956 6.16562C8.18743 6.02776 8.26488 5.84078 8.26488 5.64581C8.26488 5.45084 8.18743 5.26386 8.04956 5.126C7.9117 4.98814 7.72472 4.91069 7.52976 4.91069H6.79464C6.59967 4.91069 6.41269 4.98814 6.27483 5.126C6.13697 5.26386 6.05952 5.45084 6.05952 5.64581C6.05952 5.84078 6.13697 6.02776 6.27483 6.16562C6.41269 6.30348 6.59967 6.38093 6.79464 6.38093V6.38093ZM6.79464 9.32141H7.52976C7.72472 9.32141 7.9117 9.24396 8.04956 9.10609C8.18743 8.96823 8.26488 8.78125 8.26488 8.58629C8.26488 8.39132 8.18743 8.20434 8.04956 8.06648C7.9117 7.92862 7.72472 7.85117 7.52976 7.85117H6.79464C6.59967 7.85117 6.41269 7.92862 6.27483 8.06648C6.13697 8.20434 6.05952 8.39132 6.05952 8.58629C6.05952 8.78125 6.13697 8.96823 6.27483 9.10609C6.41269 9.24396 6.59967 9.32141 6.79464 9.32141V9.32141ZM15.6161 15.2024H14.8809V2.70533C14.8809 2.51037 14.8035 2.32339 14.6656 2.18553C14.5278 2.04766 14.3408 1.97021 14.1458 1.97021H3.85416C3.6592 1.97021 3.47221 2.04766 3.33435 2.18553C3.19649 2.32339 3.11904 2.51037 3.11904 2.70533V15.2024H2.38392C2.18896 15.2024 2.00198 15.2798 1.86412 15.4177C1.72625 15.5555 1.6488 15.7425 1.6488 15.9375C1.6488 16.1324 1.72625 16.3194 1.86412 16.4573C2.00198 16.5951 2.18896 16.6726 2.38392 16.6726H15.6161C15.811 16.6726 15.998 16.5951 16.1359 16.4573C16.2737 16.3194 16.3512 16.1324 16.3512 15.9375C16.3512 15.7425 16.2737 15.5555 16.1359 15.4177C15.998 15.2798 15.811 15.2024 15.6161 15.2024ZM9.73511 15.2024H8.26488V12.2619H9.73511V15.2024ZM13.4107 15.2024H11.2054V11.5268C11.2054 11.3318 11.1279 11.1448 10.99 11.007C10.8522 10.8691 10.6652 10.7916 10.4702 10.7916H7.52976C7.33479 10.7916 7.14781 10.8691 7.00995 11.007C6.87209 11.1448 6.79464 11.3318 6.79464 11.5268V15.2024H4.58928V3.44045H13.4107V15.2024Z"
          fill="#0000009c"
        />
      </svg>
      <p style={{ margin: '2px 0px', fontSize: '11px !important', fontWeight: 500 }}>AGENCY</p>
      <p style={{ margin: 0 }}>Auto Cascade - Tier {tier?.rank ?? 0}</p>
    </div>
  )
}

// Shift Type Icon -----
export function AgencyAwaitingCascadeIcon({ text }) {
  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        fontSize: '10px',
        flexDirection: 'column',
        lineHeight: '10px',
      }}
    >
      <svg fill="none" height="30" viewBox="0 0 27 30" width="27" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M20 1.16666C18.8463 1.16666 17.7185 1.50878 16.7592 2.14975C15.7999 2.79073 15.0522 3.70177 14.6107 4.76767C14.1692 5.83357 14.0537 7.00646 14.2787 8.13802C14.5038 9.26957 15.0594 10.309 15.8752 11.1248C16.691 11.9406 17.7304 12.4962 18.862 12.7212C19.9935 12.9463 21.1664 12.8308 22.2323 12.3893C23.2982 11.9478 24.2093 11.2001 24.8502 10.2408C25.4912 9.28153 25.8333 8.15371 25.8333 6.99999C25.8333 6.23395 25.6824 5.4754 25.3893 4.76767C25.0961 4.05994 24.6665 3.41688 24.1248 2.8752C23.5831 2.33353 22.94 1.90384 22.2323 1.61069C21.5246 1.31754 20.766 1.16666 20 1.16666V1.16666ZM20 11.6667C19.077 11.6667 18.1748 11.393 17.4073 10.8802C16.6399 10.3674 16.0418 9.63857 15.6886 8.78585C15.3353 7.93312 15.2429 6.99481 15.423 6.08957C15.6031 5.18432 16.0475 4.3528 16.7002 3.70016C17.3528 3.04751 18.1843 2.60306 19.0896 2.42299C19.9948 2.24293 20.9331 2.33534 21.7858 2.68855C22.6386 3.04176 23.3674 3.6399 23.8802 4.40733C24.393 5.17476 24.6667 6.07701 24.6667 6.99999C24.6667 8.23767 24.175 9.42465 23.2998 10.2998C22.4247 11.175 21.2377 11.6667 20 11.6667V11.6667ZM21.8083 7.36749L20.5833 6.66166V4.08332C20.5833 3.92861 20.5219 3.78024 20.4125 3.67084C20.3031 3.56145 20.1547 3.49999 20 3.49999C19.8453 3.49999 19.6969 3.56145 19.5875 3.67084C19.4781 3.78024 19.4167 3.92861 19.4167 4.08332V6.99999C19.4167 6.99999 19.4167 7.04666 19.4167 7.06999C19.4201 7.11018 19.43 7.14957 19.4458 7.18666C19.4578 7.22127 19.4735 7.25451 19.4925 7.28582C19.5085 7.31898 19.528 7.35028 19.5508 7.37916L19.6442 7.45499L19.6967 7.50749L21.2133 8.38249C21.3022 8.43288 21.4028 8.45903 21.505 8.45832C21.6342 8.45923 21.76 8.41724 21.8627 8.33894C21.9654 8.26064 22.0392 8.15046 22.0726 8.02568C22.106 7.9009 22.097 7.76858 22.047 7.64946C21.9971 7.53034 21.909 7.43117 21.7967 7.36749H21.8083Z"
          fill="#7C7D80"
        />
        <path
          d="M10.4702 17.3809H11.2054C11.4003 17.3809 11.5873 17.3035 11.7252 17.1656C11.863 17.0278 11.9405 16.8408 11.9405 16.6458C11.9405 16.4508 11.863 16.2639 11.7252 16.126C11.5873 15.9881 11.4003 15.9107 11.2054 15.9107H10.4702C10.2753 15.9107 10.0883 15.9881 9.95042 16.126C9.81256 16.2639 9.73511 16.4508 9.73511 16.6458C9.73511 16.8408 9.81256 17.0278 9.95042 17.1656C10.0883 17.3035 10.2753 17.3809 10.4702 17.3809ZM10.4702 20.3214H11.2054C11.4003 20.3214 11.5873 20.244 11.7252 20.1061C11.863 19.9682 11.9405 19.7813 11.9405 19.5863C11.9405 19.3913 11.863 19.2043 11.7252 19.0665C11.5873 18.9286 11.4003 18.8512 11.2054 18.8512H10.4702C10.2753 18.8512 10.0883 18.9286 9.95042 19.0665C9.81256 19.2043 9.73511 19.3913 9.73511 19.5863C9.73511 19.7813 9.81256 19.9682 9.95042 20.1061C10.0883 20.244 10.2753 20.3214 10.4702 20.3214ZM6.79464 17.3809H7.52976C7.72472 17.3809 7.9117 17.3035 8.04956 17.1656C8.18743 17.0278 8.26488 16.8408 8.26488 16.6458C8.26488 16.4508 8.18743 16.2639 8.04956 16.126C7.9117 15.9881 7.72472 15.9107 7.52976 15.9107H6.79464C6.59967 15.9107 6.41269 15.9881 6.27483 16.126C6.13697 16.2639 6.05952 16.4508 6.05952 16.6458C6.05952 16.8408 6.13697 17.0278 6.27483 17.1656C6.41269 17.3035 6.59967 17.3809 6.79464 17.3809ZM6.79464 20.3214H7.52976C7.72472 20.3214 7.9117 20.244 8.04956 20.1061C8.18743 19.9682 8.26488 19.7813 8.26488 19.5863C8.26488 19.3913 8.18743 19.2043 8.04956 19.0665C7.9117 18.9286 7.72472 18.8512 7.52976 18.8512H6.79464C6.59967 18.8512 6.41269 18.9286 6.27483 19.0665C6.13697 19.2043 6.05952 19.3913 6.05952 19.5863C6.05952 19.7813 6.13697 19.9682 6.27483 20.1061C6.41269 20.244 6.59967 20.3214 6.79464 20.3214ZM15.6161 26.2024H14.8809V13.7053C14.8809 13.5104 14.8035 13.3234 14.6656 13.1855C14.5278 13.0477 14.3408 12.9702 14.1458 12.9702H3.85416C3.6592 12.9702 3.47221 13.0477 3.33435 13.1855C3.19649 13.3234 3.11904 13.5104 3.11904 13.7053V26.2024H2.38392C2.18896 26.2024 2.00198 26.2798 1.86412 26.4177C1.72625 26.5555 1.6488 26.7425 1.6488 26.9375C1.6488 27.1324 1.72625 27.3194 1.86412 27.4573C2.00198 27.5951 2.18896 27.6726 2.38392 27.6726H15.6161C15.811 27.6726 15.998 27.5951 16.1359 27.4573C16.2737 27.3194 16.3512 27.1324 16.3512 26.9375C16.3512 26.7425 16.2737 26.5555 16.1359 26.4177C15.998 26.2798 15.811 26.2024 15.6161 26.2024ZM9.73511 26.2024H8.26488V23.2619H9.73511V26.2024ZM13.4107 26.2024H11.2054V22.5268C11.2054 22.3318 11.1279 22.1448 10.99 22.007C10.8522 21.8691 10.6652 21.7916 10.4702 21.7916H7.52976C7.33479 21.7916 7.14781 21.8691 7.00995 22.007C6.87209 22.1448 6.79464 22.3318 6.79464 22.5268V26.2024H4.58928V14.4405H13.4107V26.2024Z"
          fill="black"
          fillOpacity="0.611765"
        />
      </svg>
      <p style={{ margin: '2px 0px', fontSize: '11px !important', fontWeight: 500, textAlign: 'center' }}>
        Auto Casecade Send to Agency:
      </p>
      <span style={{ margin: 0 }}>{moment(text).format('Do MMM YY - HH:mm')}</span>
    </div>
  )
}

export function BankShiftIcon() {
  return (
    <svg
      fill="none"
      height="32"
      style={{ width: '100%' }}
      viewBox="0 0 28 29"
      width="32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M12.1153 1.23962C11.164 1.23962 10.3928 2.01083 10.3928 2.96216V2.97827H10.2887C9.33738 2.97827 8.56618 3.74948 8.56618 4.70081V4.71688H8.46213C7.5108 4.71688 6.73959 5.48809 6.73959 6.43942V13.6515C6.73959 14.6029 7.5108 15.3741 8.46213 15.3741H16.1434C17.0947 15.3741 17.8659 14.6029 17.8659 13.6515V13.6355H17.97C18.9213 13.6355 19.6925 12.8643 19.6925 11.9129V11.8968H19.7966C20.7479 11.8968 21.5191 11.1256 21.5191 10.1743V2.96216C21.5191 2.01083 20.7479 1.23962 19.7966 1.23962H12.1153ZM11.7773 2.96216C11.7773 2.77545 11.9286 2.62409 12.1153 2.62409H19.7966C19.9833 2.62409 20.1347 2.77545 20.1347 2.96216V10.1743C20.1347 10.361 19.9833 10.5124 19.7966 10.5124H19.6925V4.70081C19.6925 3.74948 18.9213 2.97827 17.97 2.97827H11.7773V2.96216ZM9.95065 4.70081C9.95065 4.5141 10.102 4.36274 10.2887 4.36274H17.97C18.1567 4.36274 18.3081 4.5141 18.3081 4.70081V11.9129C18.3081 12.0996 18.1567 12.251 17.97 12.251H17.8659V6.43942C17.8659 5.48809 17.0947 4.71688 16.1434 4.71688H9.95065V4.70081ZM8.12406 6.43942C8.12406 6.25271 8.27542 6.10135 8.46213 6.10135H16.1434C16.3301 6.10135 16.4815 6.25271 16.4815 6.43942V13.6515C16.4815 13.8383 16.3301 13.9896 16.1434 13.9896H8.46213C8.27542 13.9896 8.12406 13.8383 8.12406 13.6515V6.43942ZM11.9222 6.9707C11.6758 6.9707 11.4597 7.16409 11.4597 7.41944V9.23455H9.54381C9.29738 9.23455 9.08132 9.42794 9.08132 9.68329V10.4077C9.08132 10.6631 9.29738 10.8565 9.54381 10.8565H11.4597V12.6716C11.4597 12.9269 11.6758 13.1203 11.9222 13.1203H12.6833C12.9297 13.1203 13.1458 12.9269 13.1458 12.6716V10.8565H15.0617C15.3081 10.8565 15.5242 10.6631 15.5242 10.4077V9.68329C15.5242 9.42794 15.3081 9.23455 15.0617 9.23455H13.1458V7.41944C13.1458 7.16409 12.9297 6.9707 12.6833 6.9707H11.9222Z"
        fill="#007AC3"
        fillRule="evenodd"
      />
      <path
        d="M4.35031 26C5.62031 26 6.29031 25.2 6.29031 24.2C6.29031 23.36 5.72031 22.67 5.01031 22.56C5.64031 22.43 6.16031 21.87 6.16031 21.03C6.16031 20.14 5.51031 19.33 4.24031 19.33H0.730312V26H4.35031ZM3.93031 22H2.15031V20.55H3.93031C4.41031 20.55 4.71031 20.86 4.71031 21.28C4.71031 21.7 4.41031 22 3.93031 22ZM3.98031 24.77H2.15031V23.22H3.98031C4.54031 23.22 4.84031 23.58 4.84031 24C4.84031 24.48 4.52031 24.77 3.98031 24.77ZM13.8312 26L11.2612 19.33H9.48117L6.90117 26H8.52117L8.94117 24.87H11.8012L12.2112 26H13.8312ZM11.4112 23.62H9.33117L10.3712 20.75L11.4112 23.62ZM20.6671 26V19.33H19.2471V23.52L16.1571 19.33H14.6971V26H16.1171V21.65L19.2971 26H20.6671ZM27.9423 26L25.1123 22.46L27.7623 19.33H26.0123L23.6523 22.31V19.33H22.2323V26H23.6523V23.95L24.1723 23.33L26.1923 26H27.9423Z"
        fill="#007AC3"
      />
    </svg>
  )
}
